import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointTablet } from 'src/styles/breakpoints';
import { spacing2, spacing3 } from 'src/styles/spacing';

export const StyledCreditCheck = styled(Typography)`
  margin-top: ${spacing3};

  @media (min-width: ${breakpointTablet}) {
    margin-top: ${spacing2};
  }
`;
